import { lazy, Suspense, useEffect } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";

// Only the game itself loads up front; the other pages download when someone opens them.
const NotFound = lazy(() => import("./pages/NotFound"));
const Contact = lazy(() => import("./pages/Contact"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const FAQ = lazy(() => import("./pages/FAQ"));
const HowItWorks = lazy(() => import("./pages/HowItWorks"));
const CreatorPage = lazy(() => import("./pages/CreatorPage"));
const CreatorVersePage = lazy(() => import("./pages/CreatorVersePage"));
const GalleryPage = lazy(() => import("./pages/GalleryPage"));
const GalleryPlayPage = lazy(() => import("./pages/GalleryPlayPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
import { ensureSupabaseSession } from "@/lib/supabase";
import { BirthdayEvent } from "@/components/BirthdayEvent";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    void ensureSupabaseSession();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Sonner />
        <BirthdayEvent />
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/creator" element={<CreatorPage />} />
            <Route path="/creator/:id" element={<CreatorVersePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/play/:id" element={<GalleryPlayPage />} />
            <Route path="/mod" element={<AdminPage />} />
            <Route path="/mod/preview/:id" element={<GalleryPlayPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
